import { SVGAttributes } from 'react'

const LightningIcon = ({ className, fill = '#C2C4C8', ...props }: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.1721 8.30894C15.1508 8.21879 15.1076 8.13529 15.0463 8.06586C14.985 7.99643 14.9074 7.94323 14.8206 7.91097L10.7699 6.39152L11.8007 1.2355C11.824 1.1157 11.8077 0.991566 11.7543 0.881818C11.7009 0.77207 11.6133 0.682668 11.5046 0.627104C11.396 0.571539 11.2722 0.552826 11.1519 0.57379C11.0317 0.594753 10.9215 0.654254 10.8381 0.743315L2.96308 9.18082C2.89912 9.24821 2.85286 9.3304 2.82841 9.42004C2.80397 9.50968 2.80211 9.60398 2.823 9.69451C2.84389 9.78505 2.88688 9.869 2.94814 9.93886C3.00939 10.0087 3.087 10.0623 3.17402 10.0949L7.22613 11.6143L6.19816 16.7647C6.17482 16.8845 6.19108 17.0087 6.24448 17.1184C6.29788 17.2282 6.38553 17.3176 6.4942 17.3731C6.60287 17.4287 6.72666 17.4474 6.84689 17.4264C6.96713 17.4055 7.07729 17.346 7.16074 17.2569L15.0357 8.81941C15.0985 8.752 15.1438 8.6702 15.1676 8.58119C15.1914 8.49218 15.193 8.39869 15.1721 8.30894ZM7.68949 15.047L8.42566 11.364C8.45201 11.2334 8.43113 11.0977 8.36675 10.981C8.30237 10.8643 8.19866 10.7743 8.0741 10.727L4.35879 9.33128L10.3086 2.95675L9.57316 6.63972C9.54682 6.77034 9.56769 6.90607 9.63208 7.02273C9.69646 7.1394 9.80017 7.22942 9.92473 7.27675L13.6372 8.66894L7.68949 15.047Z"
        fill={fill}
      />
    </svg>
  )
}

export default LightningIcon
